export default __webpack_public_path__ + "static/media/34309_18-58_tn.5977ff5a.jpg";